import { RiCheckLine, RiCloseLine } from '@remixicon/react';

import { Text } from '@spotify-internal/encore-web';

import styles from './ToolResultMessage.module.css';

export const ToolResultMessage = ({
  content,
  success,
}: {
  content: string;
  success: boolean;
}) => {
  return (
    <div className={styles.root}>
      {success ? (
        <RiCheckLine
          size={16}
          className={styles.icon}
          style={{ color: 'var(--essential-positive)' }}
        />
      ) : (
        <RiCloseLine
          size={16}
          className={styles.icon}
          style={{ color: 'var(--essential-negative)' }}
        />
      )}
      <div className={styles.content}>
        {content ? (
          <Text
            as="div"
            variant="marginal"
            semanticColor="textSubdued"
            className={styles.monoContent}
          >
            {content}
          </Text>
        ) : (
          <Text variant="bodySmall" semanticColor="textSubdued">
            {success ? 'Tool completed successfully' : 'Tool call failed'}
          </Text>
        )}
      </div>
    </div>
  );
};
